import { render } from "./KODetails.vue?vue&type=template&id=071e7a52"
import script from "./KODetails.vue?vue&type=script&lang=js"
export * from "./KODetails.vue?vue&type=script&lang=js"

import "./KODetails.vue?vue&type=style&index=0&id=071e7a52&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__